module.exports = __webpack_public_path__ + "img/grey_015.96730824.png";